/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { IRListIRResponse } from "./IRListIRResponse";

export type IRListIRResponseApiRespoonse = {
  data?: IRListIRResponse;
  status?: IRListIRResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace IRListIRResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
